var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsNavigationDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    d: "M6 9.207L1.611 4.818 2.318 4.111 6.003 7.79 9.646 4.146 10.354 4.854z",
    transform: "translate(-1071 -682) translate(924 565) translate(25 78) translate(122.007 39)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.01,
    strokeWidth: 0.01,
    d: "M0 0h12v12H0V0z",
    transform: "translate(-1071 -682) translate(924 565) translate(25 78) translate(122.007 39)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNavigationDown);
export default __webpack_public_path__ + "static/media/icons-navigation-down.85aa3d60c956c945af3a4d9dc8ae9307.svg";
export { ForwardRef as ReactComponent };